
export { getTrailDifficultyLabelFromNumber } from "/app/packages/trails/src/utils/trailDifficultyHelpers.ts"